"use client";

import { useState, useEffect } from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Loader, Check, Clock } from "lucide-react";
export default function ConfirmarAsistencia() {
  return <section id="confirmar-asistencia" className="dark bg-background text-foreground py-16 px-4 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
      </div>

      <div className="container max-w-2xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-[2.125rem] font-display font-semibold mb-4">
            Confirmar Asistencia
          </h2>
          <p className="text-foreground/80 max-w-xl mx-auto">
            Nos encantaría contar con tu presencia. Por favor, completa el formulario para confirmar tu asistencia.
          </p>
        </div>

        <FormProvider className="glass-effect p-8" formId="rsvp_form_home" sectionName="confirmar-asistencia" defaultValues={{
        nombre: "",
        email: "",
        numero_invitados: 1,
        asistencia: "Sí, asistiré",
        uso_bus: "Sí, usaré el bus",
        numero_bus: "",
        comentarios: ""
      }} validationRules={{
        nombre: {
          required: true,
          minLength: 2
        },
        email: {
          required: true,
          pattern: "email"
        },
        numero_invitados: {
          required: true,
          min: 1,
          max: 5
        },
        asistencia: {
          required: true
        },
        uso_bus: {
          required: true
        },
        numero_bus: {
          required: false,
          min: 1,
          max: 5
        },
        comentarios: {
          required: false
        }
      }} submitText="Confirmar Asistencia" successMessage="¡Gracias! Tu confirmación ha sido recibida correctamente.">
          <RsvpForm />
        </FormProvider>
      </div>
    </section>;
}
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date("2026-08-08T12:30:00").getTime();
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(difference % (1000 * 60) / 1000)
        });
      } else {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      }
    };
    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, []);
  const timeUnits = [{
    label: "Días",
    value: timeLeft.days
  }, {
    label: "Horas",
    value: timeLeft.hours
  }, {
    label: "Minutos",
    value: timeLeft.minutes
  }, {
    label: "Segundos",
    value: timeLeft.seconds
  }];
  return <div className="mt-8 p-6 rounded-[var(--radius-lg)] bg-primary/10 border-2 border-primary/30 relative overflow-hidden">
      
      <div className="relative z-10">
        <div className="flex items-center justify-center gap-2 mb-4">
          <Clock className="size-5 text-foreground" />
          <h3 className="text-lg font-semibold text-foreground">
            Cuenta Regresiva para el Gran Día
          </h3>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {timeUnits.map((unit, i) => <div key={unit.label} data-index={i} className="flex flex-col items-center justify-center p-4 rounded-[var(--radius-md)] bg-background/50 backdrop-blur-sm border border-primary/20 hover:border-primary/40">
              <div className="text-3xl md:text-4xl font-display font-bold text-foreground mb-1">
                {String(unit.value).padStart(2, '0')}
              </div>
              <div className="text-xs md:text-sm text-foreground/70 uppercase tracking-wider">
                {unit.label}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}
function RsvpForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center py-12 space-y-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 text-foreground mb-4">
          <Check className="size-8" />
        </div>
        <p className="text-lg text-foreground">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4">
          Enviar Otra Confirmación
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="nombre" rules={{
      required: "El nombre completo es requerido",
      minLength: {
        value: 2,
        message: "El nombre debe tener al menos 2 caracteres"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Nombre Completo</FormLabel>
            <FormControl>
              <Input placeholder="Juan Pérez" className="rounded-[var(--radius-lg)] border-[length:var(--border-thick)] focus:border-primary" {...field} />
            </FormControl>
            <FormDescription>
              Escriba su nombre tal como aparecerá en la lista de invitados.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "El correo electrónico es requerido",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Ingrese un correo electrónico válido"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Correo Electrónico</FormLabel>
            <FormControl>
              <Input type="email" placeholder="juan@example.com" className="rounded-[var(--radius-lg)] border-[length:var(--border-thick)] focus:border-primary" {...field} />
            </FormControl>
            <FormDescription>
              Usaremos este correo para enviar información importante del evento.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="numero_invitados" rules={{
      required: "El número de personas es requerido",
      min: {
        value: 1,
        message: "Debe haber al menos 1 persona"
      },
      max: {
        value: 5,
        message: "Máximo 5 personas permitidas"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Número de Personas</FormLabel>
            <FormControl>
              <Input type="number" placeholder="1" min={1} max={5} className="rounded-[var(--radius-lg)] border-[length:var(--border-thick)] focus:border-primary" {...field} onChange={e => field.onChange(Number(e.target.value))} />
            </FormControl>
            <FormDescription>
              Incluya a usted y a los acompañantes (máximo 5).
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="asistencia" rules={{
      required: "Debe seleccionar una opción"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>¿Asistirá?</FormLabel>
            <FormControl>
              <div className="space-y-3">
                <label className="flex items-center space-x-3 cursor-pointer group">
                  <input type="radio" value="Sí, asistiré" checked={field.value === "Sí, asistiré"} onChange={field.onChange} className="w-5 h-5 border-[length:var(--border-thick)] border-border text-foreground focus:ring-primary focus:ring-offset-0 focus:ring-2 cursor-pointer" />
                  <span className="text-foreground group-hover:text-foreground">
                    Sí, asistiré
                  </span>
                </label>
                <label className="flex items-center space-x-3 cursor-pointer group">
                  <input type="radio" value="No, no podré asistir" checked={field.value === "No, no podré asistir"} onChange={field.onChange} className="w-5 h-5 border-[length:var(--border-thick)] border-border text-foreground focus:ring-primary focus:ring-offset-0 focus:ring-2 cursor-pointer" />
                  <span className="text-foreground group-hover:text-foreground">
                    No, no podré asistir
                  </span>
                </label>
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="uso_bus" rules={{
      required: "Debe seleccionar una opción"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>¿Utilizará el servicio de bus?</FormLabel>
            <FormControl>
              <div className="space-y-3">
                <label className="flex items-center space-x-3 cursor-pointer group">
                  <input type="radio" value="Sí, usaré el bus" checked={field.value === "Sí, usaré el bus"} onChange={field.onChange} className="w-5 h-5 border-[length:var(--border-thick)] border-border text-foreground focus:ring-primary focus:ring-offset-0 focus:ring-2 cursor-pointer" />
                  <span className="text-foreground group-hover:text-foreground">
                    Sí, usaré el bus
                  </span>
                </label>
                <label className="flex items-center space-x-3 cursor-pointer group">
                  <input type="radio" value="No, no usaré el bus" checked={field.value === "No, no usaré el bus"} onChange={field.onChange} className="w-5 h-5 border-[length:var(--border-thick)] border-border text-foreground focus:ring-primary focus:ring-offset-0 focus:ring-2 cursor-pointer" />
                  <span className="text-foreground group-hover:text-foreground">
                    No, no usaré el bus
                  </span>
                </label>
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="numero_bus" rules={{
      min: {
        value: 1,
        message: "Debe haber al menos 1 persona"
      },
      max: {
        value: 5,
        message: "Máximo 5 personas permitidas"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Número de asientos en el bus</FormLabel>
            <FormControl>
              <Input type="number" placeholder="1" min={1} max={5} className="rounded-[var(--radius-lg)] border-[length:var(--border-thick)] focus:border-primary" {...field} onChange={e => field.onChange(e.target.value === "" ? "" : Number(e.target.value))} />
            </FormControl>
            <FormDescription>
              Indique cuántas personas (incluido usted) viajarán en el bus.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="comentarios" render={({
      field
    }) => <FormItem>
            <FormLabel>Alergias / Observaciones / Requerimientos especiales</FormLabel>
            <FormControl>
              <textarea placeholder="Ej.: Necesidad de menú vegetariano, alergias, etc." rows={4} className="flex w-full rounded-[var(--radius-lg)] border-[length:var(--border-thick)] border-border bg-white dark:bg-input/30 px-4 py-3 text-foreground placeholder:text-muted-foreground focus:border-primary focus:ring-[length:var(--border-md)] focus:ring-primary/50 outline-none resize-none" {...field} />
            </FormControl>
            <FormDescription>
              Opcional. Compártanos cualquier detalle que deba conocer el equipo organizador.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-red-500/10 border-2 border-red-500/50 rounded-[var(--radius-lg)]">
          <p className="text-red-400">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-base font-semibold rounded-[var(--radius-lg)] bg-primary text-foreground-primary hover:bg-primary-hover shadow-medium">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Enviando...
          </> : "Confirmar Asistencia"}
      </Button>

      <CountdownTimer />
    </Form>;
}